module.exports = {
      id: "search-white-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#search-white",
      toString: function () {
        return this.url;
      }
    }